export const countryList = [
  {
    label: 'United Arab Emirates',
    value: '+971',
    shortName: 'AE',
    countryCode: '971'
  },
  {
    label: 'Afghanistan',
    value: '+93',
    shortName: 'AF',
    countryCode: '93'
  },
  {
    label: 'Albania',
    value: '+355',
    shortName: 'AL',
    countryCode: '355'
  },
  {
    label: 'Armenia',
    value: '+374',
    shortName: 'AM',
    countryCode: '374'
  },
  {
    label: 'Angola',
    value: '+244',
    shortName: 'AO',
    countryCode: '244'
  },
  {
    label: 'Argentina',
    value: '+54',
    shortName: 'AR',
    countryCode: '54'
  },
  {
    label: 'Austria',
    value: '+43',
    shortName: 'AT',
    countryCode: '43'
  },
  {
    label: 'Australia',
    value: '+61',
    shortName: 'AU',
    countryCode: '61'
  },
  {
    label: 'Azerbaijan',
    value: '+994',
    shortName: 'AZ',
    countryCode: '994'
  },
  {
    label: 'Bangladesh',
    value: '+880',
    shortName: 'BD',
    countryCode: '880'
  },
  {
    label: 'Belgium',
    value: '+32',
    shortName: 'BE',
    countryCode: '32'
  },
  {
    label: 'Burkina Faso',
    value: '+226',
    shortName: 'BF',
    countryCode: '226'
  },
  {
    label: 'Bulgaria',
    value: '+359',
    shortName: 'BG',
    countryCode: '359'
  },
  {
    label: 'Bahrain',
    value: '+973',
    shortName: 'BH',
    countryCode: '973'
  },
  {
    label: 'Burundi',
    value: '+257',
    shortName: 'BI',
    countryCode: '257'
  },
  {
    label: 'Benin',
    value: '+229',
    shortName: 'BJ',
    countryCode: '229'
  },
  {
    label: 'Brunei Darussalam',
    value: '+673',
    shortName: 'BN',
    countryCode: '673'
  },
  {
    label: 'Bolivia',
    value: '+591',
    shortName: 'BO',
    countryCode: '591'
  },
  {
    label: 'Brazil',
    value: '+55',
    shortName: 'BR',
    countryCode: '55'
  },
  {
    label: 'Botswana',
    value: '+267',
    shortName: 'BW',
    countryCode: '267'
  },
  {
    label: 'Belarus',
    value: '+375',
    shortName: 'BY',
    countryCode: '375'
  },
  {
    label: 'Canada',
    value: '+1',
    shortName: 'CA',
    countryCode: '1'
  },
  {
    label: 'Congo',
    value: '+242',
    shortName: 'CG',
    countryCode: '242'
  },
  {
    label: 'Switzerland',
    value: '+41',
    shortName: 'CH',
    countryCode: '41'
  },
  {
    label: 'Ivory Coast',
    value: '+225',
    shortName: 'CI',
    countryCode: '225'
  },
  {
    label: 'Chile',
    value: '+56',
    shortName: 'CL',
    countryCode: '56'
  },
  {
    label: 'Cameroon',
    value: '+237',
    shortName: 'CM',
    countryCode: '237'
  },
  {
    label: 'China',
    value: '+86',
    shortName: 'CN',
    countryCode: '86'
  },
  {
    label: 'Colombia',
    value: '+57',
    shortName: 'CO',
    countryCode: '57'
  },
  {
    label: 'Costa Rica',
    value: '+506',
    shortName: 'CR',
    countryCode: '506'
  },
  {
    label: 'Czech Republic',
    value: '+420',
    shortName: 'CZ',
    countryCode: '420'
  },
  {
    label: 'Germany',
    value: '+49',
    shortName: 'DE',
    countryCode: '49'
  },
  {
    label: 'Denmark',
    value: '+45',
    shortName: 'DK',
    countryCode: '45'
  },
  {
    label: 'Dominican Republic',
    value: '+1',
    shortName: 'DO',
    countryCode: '1'
  },
  {
    label: 'Algeria',
    value: '+213',
    shortName: 'DZ',
    countryCode: '213'
  },
  {
    label: 'Ecuador',
    value: '+593',
    shortName: 'EC',
    countryCode: '593'
  },
  {
    label: 'Estonia',
    value: '+372',
    shortName: 'EE',
    countryCode: '372'
  },
  {
    label: 'Egypt',
    value: '+20',
    shortName: 'EG',
    countryCode: '20'
  },
  {
    label: 'Eritrea',
    value: '+291',
    shortName: 'ER',
    countryCode: '291'
  },
  {
    label: 'Spain',
    value: '+34',
    shortName: 'ES',
    countryCode: '34'
  },
  {
    label: 'Ethiopia',
    value: '+251',
    shortName: 'ET',
    countryCode: '251'
  },
  {
    label: 'Finland',
    value: '+358',
    shortName: 'FI',
    countryCode: '358'
  },
  {
    label: 'France',
    value: '+33',
    shortName: 'FR',
    countryCode: '33'
  },
  {
    label: 'Gabon',
    value: '+241',
    shortName: 'GA',
    countryCode: '241'
  },
  {
    label: 'United Kingdom',
    value: '+44',
    shortName: 'GB',
    countryCode: '44'
  },
  {
    label: 'Georgia',
    value: '+995',
    shortName: 'GE',
    countryCode: '995'
  },
  {
    label: 'French Guiana',
    value: '+594',
    shortName: 'GF',
    countryCode: '594'
  },
  {
    label: 'Ghana',
    value: '+233',
    shortName: 'GH',
    countryCode: '233'
  },
  {
    label: 'Gambia',
    value: '+220',
    shortName: 'GM',
    countryCode: '220'
  },
  {
    label: 'Greece',
    value: '+30',
    shortName: 'GR',
    countryCode: '30'
  },
  {
    label: 'Guatemala',
    value: '+502',
    shortName: 'GT',
    countryCode: '502'
  },
  {
    label: 'Guinea-Bissau',
    value: '+245',
    shortName: 'GW',
    countryCode: '245'
  },
  {
    label: 'Hong Kong',
    value: '+852',
    shortName: 'HK',
    countryCode: '852'
  },
  {
    label: 'Honduras',
    value: '+504',
    shortName: 'HN',
    countryCode: '504'
  },
  {
    label: 'Croatia',
    value: '+385',
    shortName: 'HR',
    countryCode: '385'
  },
  {
    label: 'Haiti',
    value: '+509',
    shortName: 'HT',
    countryCode: '509'
  },
  {
    label: 'Hungary',
    value: '+36',
    shortName: 'HU',
    countryCode: '36'
  },
  {
    label: 'Indonesia',
    value: '+62',
    shortName: 'ID',
    countryCode: '62'
  },
  {
    label: 'Ireland',
    value: '+353',
    shortName: 'IE',
    countryCode: '353'
  },
  {
    label: 'Israel',
    value: '+972',
    shortName: 'IL',
    countryCode: '972'
  },
  {
    label: 'India',
    value: '+91',
    shortName: 'IN',
    countryCode: '91'
  },
  {
    label: 'Iraq',
    value: '+964',
    shortName: 'IQ',
    countryCode: '964'
  },
  {
    label: 'Italy',
    value: '+39',
    shortName: 'IT',
    countryCode: '39'
  },
  {
    label: 'Jamaica',
    value: '+1',
    shortName: 'JM',
    countryCode: '1'
  },
  {
    label: 'Jordan',
    value: '+962',
    shortName: 'JO',
    countryCode: '962'
  },
  {
    label: 'Japan',
    value: '+81',
    shortName: 'JP',
    countryCode: '81'
  },
  {
    label: 'Kenya',
    value: '+254',
    shortName: 'KE',
    countryCode: '254'
  },
  {
    label: 'Cambodia',
    value: '+855',
    shortName: 'KH',
    countryCode: '855'
  },
  {
    label: 'South Korea',
    value: '+82',
    shortName: 'KR',
    countryCode: '82'
  },
  {
    label: 'Kuwait',
    value: '+965',
    shortName: 'KW',
    countryCode: '965'
  },
  {
    label: 'Laos',
    value: '+856',
    shortName: 'LA',
    countryCode: '856'
  },
  {
    label: 'Lebanon',
    value: '+961',
    shortName: 'LB',
    countryCode: '961'
  },
  {
    label: 'Sri Lanka',
    value: '+94',
    shortName: 'LK',
    countryCode: '94'
  },
  {
    label: 'Liberia',
    value: '+231',
    shortName: 'LR',
    countryCode: '231'
  },
  {
    label: 'Lesotho',
    value: '+266',
    shortName: 'LS',
    countryCode: '266'
  },
  {
    label: 'Lithuania',
    value: '+370',
    shortName: 'LT',
    countryCode: '370'
  },
  {
    label: 'Luxembourg',
    value: '+352',
    shortName: 'LU',
    countryCode: '352'
  },
  {
    label: 'Latvia',
    value: '+371',
    shortName: 'LV',
    countryCode: '371'
  },
  {
    label: 'Libya',
    value: '+218',
    shortName: 'LY',
    countryCode: '218'
  },
  {
    label: 'Morocco',
    value: '+212',
    shortName: 'MA',
    countryCode: '212'
  },
  {
    label: 'Monaco',
    value: '+377',
    shortName: 'MC',
    countryCode: '377'
  },
  {
    label: 'Moldova',
    value: '+373',
    shortName: 'MD',
    countryCode: '373'
  },
  {
    label: 'Madagascar',
    value: '+261',
    shortName: 'MG',
    countryCode: '261'
  },
  {
    label: 'Macedonia',
    value: '+389',
    shortName: 'MK',
    countryCode: '389'
  },
  {
    label: 'Mali',
    value: '+223',
    shortName: 'ML',
    countryCode: '223'
  },
  {
    label: 'Myanmar',
    value: '+95',
    shortName: 'MM',
    countryCode: '95'
  },
  {
    label: 'Mongolia',
    value: '+976',
    shortName: 'MN',
    countryCode: '976'
  },
  {
    label: 'Mauritania',
    value: '+222',
    shortName: 'MR',
    countryCode: '222'
  },
  {
    label: 'The Republic of Malta',
    value: '+356',
    shortName: 'MT',
    countryCode: '356'
  },
  {
    label: 'Malawi',
    value: '+265',
    shortName: 'MW',
    countryCode: '265'
  },
  {
    label: 'Mexico',
    value: '+52',
    shortName: 'MX',
    countryCode: '52'
  },
  {
    label: 'Malaysia',
    value: '+60',
    shortName: 'MY',
    countryCode: '60'
  },
  {
    label: 'Mozambique',
    value: '+258',
    shortName: 'MZ',
    countryCode: '258'
  },
  {
    label: 'Namibia',
    value: '+264',
    shortName: 'NA',
    countryCode: '264'
  },
  {
    label: 'Niger',
    value: '+227',
    shortName: 'NE',
    countryCode: '227'
  },
  {
    label: 'Nigeria',
    value: '+234',
    shortName: 'NG',
    countryCode: '234'
  },
  {
    label: 'Nicaragua',
    value: '+505',
    shortName: 'NI',
    countryCode: '505'
  },
  {
    label: 'Netherlands',
    value: '+31',
    shortName: 'NL',
    countryCode: '31'
  },
  {
    label: 'Norway',
    value: '+47',
    shortName: 'NO',
    countryCode: '47'
  },
  {
    label: 'Nepal',
    value: '+977',
    shortName: 'NP',
    countryCode: '977'
  },
  {
    label: 'New Zealand',
    value: '+64',
    shortName: 'NZ',
    countryCode: '64'
  },
  {
    label: 'Oman',
    value: '+968',
    shortName: 'OM',
    countryCode: '968'
  },
  {
    label: 'Panama',
    value: '+507',
    shortName: 'PA',
    countryCode: '507'
  },
  {
    label: 'Peru',
    value: '+51',
    shortName: 'PE',
    countryCode: '51'
  },
  {
    label: 'Papua New Guinea',
    value: '+675',
    shortName: 'PG',
    countryCode: '675'
  },
  {
    label: 'Philippines',
    value: '+63',
    shortName: 'PH',
    countryCode: '63'
  },
  {
    label: 'Pakistan',
    value: '+92',
    shortName: 'PK',
    countryCode: '92'
  },
  {
    label: 'Poland',
    value: '+48',
    shortName: 'PL',
    countryCode: '48'
  },
  {
    label: 'Puerto Rico',
    value: '+1',
    shortName: 'PR',
    countryCode: '1'
  },
  {
    label: 'Portugal',
    value: '+351',
    shortName: 'PT',
    countryCode: '351'
  },
  {
    label: 'Paraguay',
    value: '+595',
    shortName: 'PY',
    countryCode: '595'
  },
  {
    label: 'Qatar',
    value: '+974',
    shortName: 'QA',
    countryCode: '974'
  },
  {
    label: 'Romania',
    value: '+40',
    shortName: 'RO',
    countryCode: '40'
  },
  {
    label: 'Serbia',
    value: '+381',
    shortName: 'RS',
    countryCode: '381'
  },
  {
    label: 'Russia',
    value: '+7',
    shortName: 'RU',
    countryCode: '7'
  },
  {
    label: 'Rwanda',
    value: '+250',
    shortName: 'RW',
    countryCode: '250'
  },
  {
    label: 'Saudi Arabia',
    value: '+966',
    shortName: 'SA',
    countryCode: '966'
  },
  {
    label: 'Sudan',
    value: '+249',
    shortName: 'SD',
    countryCode: '249'
  },
  {
    label: 'Sweden',
    value: '+46',
    shortName: 'SE',
    countryCode: '46'
  },
  {
    label: 'Singapore',
    value: '+65',
    shortName: 'SG',
    countryCode: '65'
  },
  {
    label: 'Slovenia',
    value: '+386',
    shortName: 'SI',
    countryCode: '386'
  },
  {
    label: 'Slovakia',
    value: '+421',
    shortName: 'SK',
    countryCode: '421'
  },
  {
    label: 'Sierra Leone',
    value: '+232',
    shortName: 'SL',
    countryCode: '232'
  },
  {
    label: 'Senegal',
    value: '+221',
    shortName: 'SN',
    countryCode: '221'
  },
  {
    label: 'Somalia',
    value: '+252',
    shortName: 'SO',
    countryCode: '252'
  },
  {
    label: 'South Sudan',
    value: '+211',
    shortName: 'SS',
    countryCode: '211'
  },
  {
    label: 'El Salvador',
    value: '+503',
    shortName: 'SV',
    countryCode: '503'
  },
  {
    label: 'Eswatini',
    value: '+268',
    shortName: 'SZ',
    countryCode: '268'
  },
  {
    label: 'Chad',
    value: '+235',
    shortName: 'TD',
    countryCode: '235'
  },
  {
    label: 'Togo',
    value: '+228',
    shortName: 'TG',
    countryCode: '228'
  },
  {
    label: 'Thailand',
    value: '+66',
    shortName: 'TH',
    countryCode: '66'
  },
  {
    label: 'Tajikistan',
    value: '+992',
    shortName: 'TJ',
    countryCode: '992'
  },
  {
    label: 'Turkmenistan',
    value: '+993',
    shortName: 'TM',
    countryCode: '993'
  },
  {
    label: 'Tunisia',
    value: '+216',
    shortName: 'TN',
    countryCode: '216'
  },
  {
    label: 'Taiwan',
    value: '+886',
    shortName: 'TW',
    countryCode: '886'
  },
  {
    label: 'Tanzania',
    value: '+255',
    shortName: 'TZ',
    countryCode: '255'
  },
  {
    label: 'Ukraine',
    value: '+380',
    shortName: 'UA',
    countryCode: '380'
  },
  {
    label: 'Uganda',
    value: '+256',
    shortName: 'UG',
    countryCode: '256'
  },
  {
    label: 'United States',
    value: '+1',
    shortName: 'US',
    countryCode: '1'
  },
  {
    label: 'Uruguay',
    value: '+598',
    shortName: 'UY',
    countryCode: '598'
  },
  {
    label: 'Uzbekistan',
    value: '+998',
    shortName: 'UZ',
    countryCode: '998'
  },
  {
    label: 'Venezuela',
    value: '+58',
    shortName: 'VE',
    countryCode: '58'
  },
  {
    label: 'Vietnam',
    value: '+84',
    shortName: 'VN',
    countryCode: '84'
  },
  {
    label: 'Yemen',
    value: '+967',
    shortName: 'YE',
    countryCode: '967'
  },
  {
    label: 'South Africa',
    value: '+27',
    shortName: 'ZA',
    countryCode: '27'
  },
  {
    label: 'Zambia',
    value: '+260',
    shortName: 'ZM',
    countryCode: '260'
  },
];
